class LinkHandler {
  constructor(config = {}){
    const {
      linkClass
    } = config;
    const links = Array.prototype.slice.call(document.querySelectorAll(linkClass));

    links.forEach(link => {
      let aTag = link.querySelector('a');
      if(aTag) {
        aTag.target = "_blank";
      }
    });
  }
} export default LinkHandler;
